import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const progressBar = ({ theme, progress = 1 }) => css`
  position: relative;
  height: ${rem(4)};
  background-color: ${theme.color.monochrome.medium};

  &::after {
    content: '';
    background-color: ${theme.color.primary.info};
    height: 100%;
    width: ${progress}%;
    position: absolute;
    transition: width 0.5s;
  }
`

export const styles = {
  progressBar,
}
